import { render, staticRenderFns } from "./DoctorPreferenceModal.vue?vue&type=template&id=207cd2e4"
import script from "./DoctorPreferenceModal.vue?vue&type=script&lang=js"
export * from "./DoctorPreferenceModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports